import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

export function canViewAffiliates(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.AffiliateRead);
}

/**
 * Mục "Người giới thiệu & đối tác" ở trang chat — y máy chủ
 * (customerchat/handler.go: AllowOrDept(affiliate.chat, "accounting")): quyền
 * affiliate.chat (quản trị, giám đốc, kế toán) HOẶC người phòng Kế toán. Trước
 * 17/10/2026 màn chỉ hỏi quyền nên kế toán trưởng (vai manager) và nhân viên kế
 * toán (vai staff) bị giấu mục này dù máy chủ cho vào (kiểm thử đóng vai M04).
 * Vai không qua cửa phòng ban (chỉ xem, đã khoá, QC, quản lý cụm) thì không.
 */
const NO_DEPT_DOOR = new Set<string>(["viewer", "coordinator", "shift_lead", "qc", "area_manager"]);

export function canChatAffiliates(staff: Staff | null): boolean {
  if (!staff) return false;
  if (hasPermission(ACTION.AffiliateChat)) return true;
  return (
    (staff.department ?? "").toLowerCase() === "accounting" &&
    !NO_DEPT_DOOR.has((staff.role ?? "").toLowerCase())
  );
}
